// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__l7GNi","loading-spinner":"Loader_loading-spinner__AXkSA"};